import { render, staticRenderFns } from "./ConsolidationOrdersTableAdmin.vue?vue&type=template&id=2ac244b9&scoped=true"
import script from "./ConsolidationOrdersTableAdmin.vue?vue&type=script&lang=js"
export * from "./ConsolidationOrdersTableAdmin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ac244b9",
  null
  
)

export default component.exports